import api from '@shared/services/api';
import { GroupedOnboardingTasks, OnboardingTask, OnboardingTasksResponse } from '../types';

export const onboardingTaskService = {
  async getTasks(): Promise<GroupedOnboardingTasks> {
    const response = await api.get<OnboardingTasksResponse>('/onboarding-tasks');
    return response.data.tasks;
  },

  async toggleTask(taskId: string): Promise<OnboardingTask> {
    const response = await api.post<{ task: OnboardingTask }>(`/onboarding-tasks/${taskId}/toggle`);
    return response.data.task;
  },

  async toggleSubtask(taskId: string, subtaskId: string): Promise<OnboardingTask> {
    const response = await api.post<{ task: OnboardingTask }>(
      `/onboarding-tasks/${taskId}/subtasks/${subtaskId}/toggle`
    );
    return response.data.task;
  },

  async resetTasks(): Promise<void> {
    await api.post('/onboarding-tasks/reset');
  }
};
